import { render, staticRenderFns } from "./QuarantineList.vue?vue&type=template&id=a2720ea0&scoped=true&"
import script from "./QuarantineList.vue?vue&type=script&lang=js&"
export * from "./QuarantineList.vue?vue&type=script&lang=js&"
import style0 from "./QuarantineList.vue?vue&type=style&index=0&id=a2720ea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2720ea0",
  null
  
)

export default component.exports